enum ButtonsType {
	None = 0,
	Basic = 1,
	MobileAddAed = 2,
}

export default ButtonsType;
